export default {
      id: "chartDropArrow-usage",
      viewBox: "0 0 12 8",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#chartDropArrow-usage",
      toString: function () {
        return this.url;
      }
    }